import { createReducer, on } from '@ngrx/store';
import { progressActions } from '../actions/progress.actions';
import { Progress } from '../models';

export interface ProgressState {
    items: Progress[];
    loaded: boolean | null;
    loading: boolean;
}

export const initialState: ProgressState = {
    items: [],
    loaded: null,
    loading: false,
};

export const progressReducer = createReducer(
    initialState,
    on(
        progressActions.getProgress,
        (state): ProgressState => ({
            ...state,
            loading: true,
        }),
    ),
    on(
        progressActions.getProgressSuccess,
        (state, { payload }): ProgressState => ({
            ...state,
            items: [...payload],
            loaded: true,
            loading: false,
        }),
    ),
    on(
        progressActions.getProgressError,
        (state): ProgressState => ({
            ...state,
            loading: false,
            loaded: false,
        }),
    ),
    on(
        progressActions.markAsCompleted,
        (state): ProgressState => ({
            ...state,
            loading: true,
        }),
    ),
    on(
        progressActions.markAsUncompleted,
        (state): ProgressState => ({
            ...state,
            loading: true,
        }),
    ),
    on(
        progressActions.clear,
        (): ProgressState => ({
            ...initialState,
        }),
    ),
);
